import { render, staticRenderFns } from "./AuthorizeComponent.vue?vue&type=template&id=34f84e88"
import script from "./AuthorizeComponent.vue?vue&type=script&lang=js"
export * from "./AuthorizeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports